<template>
  <div v-el-resize="onResize" class="relative d-flex justify-center align-center">

    <dialog-scroll-lock v-if="selected" content-class="edit-blob-dialog" width="500" :value="true" @input="selected = null">
      <v-card v-bind:style="{ 'background-color': skin.env_background_color }">
        <!-- <v-btn style="top: 12px; right: 12px;" absolute fab small color="primary" @click="selected = null">
          <v-icon v-html="mdiCheck" />
        </v-btn> -->
        <v-btn style="top: 12px; right: 12px;" absolute small color="primary" @click="selected = null">
          Done
        </v-btn>
        <v-card-text
          class="pt-10 px-6 pb-6"
          v-bind:class="{ dark: isDarkEnv, error: { from: !from, to: !to }[selected.id] }"
          style="background-color: unset !important;"
        >
          <div class="d-flex mx-n3 mb-3">
            <div class="edit-blob-label top">{{LABELS[selected.id]}}</div>
          </div>
          <div>
            <div
              v-el-resize="v => { selectedScale = v.width / selected.w }"
              class="relative fill-width fill-height d-flex justify-center align-center"
              v-bind:style="{ 'aspect-ratio': selected.w / selected.h }"
            >
              <div class="absolute" style="inset: -12px;">
                <div
                  class="edit-blob-outline"
                  style="border-top-left-radius: 0; outline-width: 2px;"
                  v-bind:style="{
                    'border-bottom-left-radius': ((selected.id == 'to') && editToMultipleRecipients) ? '0' : null
                  }"
                />
              </div>
              <div
                class="absolute"
                v-bind:style="{
                  width: selected.w + 'px',
                  height: selected.h + 'px',
                  transform: `scale(${selectedScale})`
                }"
              >
                <text-blob
                  ref="blob"
                  mode="edit"
                  :blob="selected"
                  :is-editable="{ from: editFrom, to: editTo }[selected.id]"
                  :is-selected="true"
                />
              </div>
            </div>
          </div>
          <div v-if="(selected.id == 'to') && editToMultipleRecipients" class="d-flex mx-n3 mt-3">
            <div class="edit-blob-label bottom">
              <v-checkbox
                class="pt-0 mt-0"
                hide-details readonly
                :label="editToMultipleRecipientsLabel"
                :dark="!isDarkEnv || !to"
                :disabled="editToMultipleRecipientsDisabled"
                :input-value="toMultipleRecipients"
                @click="() => {
                  $emit('update:multiple-recipients', !toMultipleRecipients);
                  $nextTick(() => editTo && !to && $refs.blob.focus());
                }"
              />
            </div>
          </div>
        </v-card-text>
      </v-card>
    </dialog-scroll-lock>

    <!-- You may find these controls useful for debugging -->
    <!--
    <div class="absolute-fill">
      <v-btn @click.capture.stop="open()">open</v-btn>
      <v-btn  @click.capture.stop="close()">close</v-btn>
      {{state}}
    </div>
    -->

    <div
      v-if="containerHeight && $slots.below"
      class="absolute"
      style="bottom: 0;"
      v-bind:style="{ width: `${width}px`, height: `${(containerHeight - width * 5 / 7) / 2}px` }"
    >
      <slot name="below"></slot>
    </div>

    <!-- Note that it's very important to gate this based on the 'containerHeight' to prevent CLS -->
    <div
      v-if="containerHeight"
      class="env" :class="state"
      v-bind:style="{ width: `${width}px`, height: `${width * 5 / 7}px` }"
    >
      <div
        class="outside-back shadow d-flex justify-center align-center"
        v-bind:class="outsideBackClass"
        v-bind:style="{ ...style, 'background-color': skin.env_background_color }"
      >
        <!-- This is reliable for the animations -->
        <!-- <card-preview class="back-card" mode="view" :card="backCard" :width="width * 5 / 7" /> -->

        <!-- TODO: this should probably be a blob instead? That way we have better control over the layering? Simpler this way though… -->
        <div class="absolute-fill back-card-gradient" />

        <!-- Blobs require exact widths in px, so we have to explicitly scale this container -->
        <div
          class="absolute"
          style="width: 840px; height: 600px; pointer-events: none;"
          v-bind:style="{ transform: `scale(${width / 840})` }"
        >

          <div
            v-for="[ blob, component, edit, editMultipleRecipients, hasError ] in blobs"
            class="absolute"
            v-bind:class="{ 'edit-blob-container': edit || editMultipleRecipients, dark: isDarkEnv }"
            v-bind:style="{
              top: (600 - blob.x - blob.h / 2) + 'px',
              left: (blob.y - blob.w / 2) + 'px',
              width: blob.w + 'px',
              height: blob.h + 'px'
            }"
            @click="() => {
              if (edit || editMultipleRecipients) {
                $emit('click:' + blob.id);
                if (isSmall && (blob.type == 'TEXT')) {
                  selected = blob;
                  if (edit && !blob.text.text)
                    $nextTick(() => $refs.blob.focus());
                }
              }
            }"
          >
            <component
              v-if="component"
              :is="component"
              :ref="blob.id"
              mode="edit"
              :tabindex="(edit && (blob.type == 'TEXT')) ? null : '0'"
              :blob="blob"
              :is-editable="edit && !isSmall"
              :is-selected="true"
              @blur="dirtyBlobIds.add(blob.id)"
            />
            <div
              v-if="edit || editMultipleRecipients"
              class="absolute"
              v-bind:style="{ inset: (blob.type == 'TEXT') ? '-12px' : '0' }"
            >
              <div
                class="edit-blob-scale"
                v-bind:class="{ error: hasError && isDirty(blob.id) }"
                v-bind:style="{
                  width: `${100 * width / 840}%`,
                  height: `${100 * width / 840}%`,
                  transform: `scale(${840 / width})`
                }"
                @click="() => edit && !isSmall && (blob.type == 'TEXT') && $refs[blob.id][0].focus()"
              >
                <div v-if="!isSmall" class="edit-blob-label top">{{LABELS[blob.id]}}</div>
                <div class="edit-blob-outline" />
                <div v-if="!isSmall && editMultipleRecipients" class="edit-blob-label bottom" @click.stop>
                  <!-- We can assume we're dealing with the 'to' text-blob if 'editMultipleRecipients' is set -->
                  <v-checkbox
                    class="pt-0 mt-0"
                    hide-details readonly
                    :label="editToMultipleRecipientsLabel"
                    :dark="!isDarkEnv || (hasError && isDirty(blob.id))"
                    :disabled="editToMultipleRecipientsDisabled"
                    :input-value="toMultipleRecipients"
                    @click="v => {
                      $emit('update:multiple-recipients', !toMultipleRecipients);
                      $nextTick(() => editTo && !to && $refs[blob.id][0].focus());
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="inside-back shadow" v-bind:style="style">
        <svg viewBox="0 0 100 72" preserveAspectRatio="none">
          <defs>
            <pattern id="img-inside-back" patternUnits="userSpaceOnUse" width="100" height="100">
              <image href="/textures/45-degree-fabric-light.png" x="0" y="0" width="100" height="100" />
            </pattern>
          </defs>
          <rect width="100" height="72" fill="#DDD" />
          <rect width="100" height="72" :fill="skin.env_background_color" fill-opacity=".5" />
          <rect
            style="filter: drop-shadow(0 0 1px rgba(0, 0, 0, .2));"
            x="4" width="92" height="68" fill="url(#img-inside-back)" stroke="#8882" stroke-width=".05"
          />
        </svg>
      </div>

      <div class="inside-flap" v-bind:style="style">
        <svg viewBox="-5 0 110 72" preserveAspectRatio="none">
          <defs>
            <linearGradient id="gradient-inside-flap" x1="0" x2="0" y1="1" y2="0">
              <stop offset="0%" stop-color="#BBB" />
              <stop offset="15%" stop-color="#DDD" />
            </linearGradient>
            <pattern id="img-inside-flap" patternUnits="userSpaceOnUse" width="100" height="100">
              <image href="/textures/45-degree-fabric-light.png" x="0" y="0" width="100" height="100" />
            </pattern>
          </defs>

          <!-- <path d="M 0 72 Q 0 67 5 62 L 45 27 Q 50 22 55 27 L 95 62 Q 100 67 100 72" style="filter: drop-shadow(0 0 4px #2224);" /> -->

          <path d="M 0 72 Q 0 67 5 62 L 45 27 Q 50 22 55 27 L 95 62 Q 100 67 100 72" fill="url(#gradient-inside-flap)" />
          <path d="M 0 72 Q 0 67 5 62 L 45 27 Q 50 22 55 27 L 95 62 Q 100 67 100 72" :fill="skin.env_background_color" fill-opacity=".5" />
          <path
            style="filter: drop-shadow(0 0 1px rgba(0, 0, 0, .2));"
            d="M 4 72 Q 4 67 10 62 L 46.75 30.5 Q 50 27 53.25 30.5 L 90 62 Q 96 67 96 72 Z"
            fill="url(#img-inside-flap)"
            stroke="#8882" stroke-width=".05"
          />
        </svg>
      </div>

      <div class="contents d-flex justify-center align-center" :class="orientation" v-bind:style="style">
        <div v-bind:style="contentsStyle">
          <slot v-bind="contentsBounds"></slot>
        </div>
      </div>

      <!--
      Safari has a bug rendering SVGs properly with the CSS animations you have applied: I believe it presents with this panel when opening the envelope because the scaleX is set to 0 at 0% in the outside-panels animation. You can try tinkering with that initial scaleX to see the results. Removing the filter entirely solves the problem, but we need the shadow. I've replaced the #dropshadow-outside-panels filter with a stroke on the third path element, but it would be better for every element to have the property: filter="url(#dropshadow-outside-panels)"

      You can reproduce this issue with desktop Safari: //open/9267a3e8-0a27-4978-b371-c94e74e04bb0

      Using your SVG filter, you can use these settings to control the shadow:
      - feGaussianBlur.stdDeviation: speard distance
      - feOffset.dx, feOffset.dy: direction
      - feFuncA.slope: darkness

      You also tried applying the CSS filter drop-shadow to both individual path elements and the svg elements themselves. That did not work in Safari at all:
      style="filter: drop-shadow(0px 0px 8px #0002);"

      The best workaround you found was to convert these SVGs to canvas elements, being careful to use an up-scaled canvas to maintain sharp lines. No idea of the performance implications, but at least it works...

      This is your original (and desired) implementation of the two components that use shadows (outside-panels and outside-flap):

      <div class="outside-panels" v-bind:style="style">
        <svg viewBox="0 0 100 72" preserveAspectRatio="none">
          <defs>
            <filter id="dropshadow-outside-panels" height="130%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
              <feOffset result="offsetblur" />
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.2"/>
              </feComponentTransfer>
              <feMerge>
                <feMergeNode/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          <path d="M 0 0 L 50 36 L 0 72" :fill="skin.env_background_color" />
          <path d="M 100 0 L 50 36 L 100 72" :fill="skin.env_background_color" />
          <path d="M 0 72 Q 0 67 5 62 L 45 27 Q 50 22 55 27 L 95 62 Q 100 67 100 72" :fill="skin.env_background_color" filter="url(#dropshadow-outside-panels)" />
        </svg>
      </div>

      <div class="outside-flap" v-bind:style="style">
        <svg viewBox="-5 0 110 72" preserveAspectRatio="none">
          <defs>
            <filter id="dropshadow-outside-flap" height="130%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
              <feOffset result="offsetblur" />
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.3" />
              </feComponentTransfer>
              <feMerge>
                <feMergeNode />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <path d="M 0 0 Q 0 5 5 10 L 45 45 Q 50 50 55 45 L 95 10 Q 100 5 100 0" :fill="skin.env_background_color" filter="url(#dropshadow-outside-flap)" />
        </svg>
      </div>

      TODO: assuming that CSS 'filter' solves the problem, you should look into how to add texture to the enevelopes:
      https://stackoverflow.com/questions/54605976/apply-a-texture-to-an-image-in-svg
      -->

      <canvas ref="outside-panels" class="outside-panels" v-bind:style="style" width="1000" height="720" />

      <canvas ref="outside-flap" class="outside-flap" v-bind:style="style" width="1100" height="720" />

    </div>
  </div>
</template>

<style scoped>
/*
I've made several attempts at getting these animations exactly right. Ideally, I'd be able to specify the state of the various components (children of '.env') and simply use CSS transitions between those states. Works great on Chrome, but there are too many cross-browser compatibility issues, particularly with iOS Safari. Be careful to test any changes here on all browsers.

Ideally, I would handle the envelope flipping around using 3D rotation transformations, but Safari has all sorts of glitches that result in flickering, particularly around when those transformations are applied to SVGs. Instead of rotating an element along the Y axis 180 degrees, you can simply alter its scale in the X direction for an almost indistinguishable effect.

Also, when dealing with keyframe animations, be careful not to set the 'transform' state for either '.closed' or '.opened' to a value that would cause it to be invisible (eg. 'transform: scaleX(0)'). Safari has an optimization bug that causes it to fail to render the element entirely, even though the 'transform' specifications from the keyframe animations should cause it to be visible. See '.env.closed > .outside-panels' for an example of where this applies.
*/

path {
  transition: fill 1s;
}

.shadow {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.env {
  position: relative;
  z-index: 1;
}

.env > * {
  position: absolute;
  width: 100%;
  height: 100%;
  animation-delay: 0s;
  animation-timing-function: ease-in;
  animation-iteration-count: 1;
  animation-play-state: paused;
  animation-fill-mode: forwards;
}
.env:not(.opened) > *:not(.outside-back) {
  pointer-events: none;
}
.env > * svg {
  width: 100%;
  height: 100%;
}
.env.opening > * {
  animation-direction: forwards;
  animation-play-state: running;
}
.env.closing > * {
  animation-direction: reverse;
  animation-play-state: running;
}
.env.opened:not(.closing) > *,
.env.closed:not(.opening) > * {
  animation-name: unset;
}

/* You could use something like the following to add textures */
/*
.outside-back::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('https://www.transparenttextures.com/patterns/groovepaper.png');
  background-repeat: repeat;
}
*/

.outside-back {
  z-index: 1;
  animation-name: outside-back;
}
.outside-back > .back-card {
  position: absolute;
  overflow: hidden;
  transform: rotate(-90deg);
}
.outside-back > .back-card-gradient {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(35.5deg, #6662 25%, #0000 75%);
}
.env.closed > .outside-back { opacity: 1; }
.env.opened > .outside-back { opacity: .00001; }
@keyframes outside-back {
  0% { opacity: 1; transform: scaleX(1); }
  12.5% { opacity: 1; transform: scaleX(0); }
  100% { opacity: 1; transform: scaleX(0); }
}

.inside-back {
  z-index: 2;
  animation-name: inside-back;
}
.env.closed > .inside-back { opacity: .00001; }
.env.opened > .inside-back { opacity: .00001; }
@keyframes inside-back {
  0% { opacity: 1; transform: scaleX(0) translateY(0); }
  12.5% { opacity: 1; transform: scaleX(0) translateY(0); }
  25% { opacity: 1; transform: scaleX(1) translateY(0); }
  50% { opacity: 1; transform: scaleX(1) translateY(0); }
  75% { opacity: 0; transform: scaleX(1) translateY(100%); }
  100% { opacity: 0; transform: scaleX(1) translateY(100%); }
}

.inside-flap {
  z-index: 3;
  margin-left: -5%;
  width: 110%;
  bottom: 100%;
  transform-origin: bottom;
  transform: scaleX(0) scaleY(0);
  animation-name: inside-flap;
}
.env.closed > .inside-flap { opacity: .00001; }
.env.opened > .inside-flap { opacity: .00001; }
@keyframes inside-flap {
  0% { opacity: 1; transform: scaleX(0) scaleY(0) translateY(0); }
  12.5% { opacity: 1; transform: scaleX(0) scaleY(0) translateY(0); }
  25% { opacity: 1; transform: scaleX(1) scaleY(0) translateY(0); }
  37.5% { opacity: 1; transform: scaleX(1) scaleY(0) translateY(0); }
  50% { opacity: 1; transform: scaleX(1) scaleY(1) translateY(0); }
  75% { opacity: .00001; transform: scaleX(1) scaleY(1) translateY(100%); }
  100% { opacity: .00001; transform: scaleX(1) scaleY(1) translateY(100%); }
}

.contents {
  z-index: 4;
}
.contents.landscape {
  animation-name: contents-landscape;
}
.contents.portrait {
  animation-name: contents-portrait;
}
.env.closed > .contents { opacity: .00001; }
.env.opened > .contents { opacity: 1; }
@keyframes contents-landscape {
  0% { opacity: 1; transform: scaleX(0); }
  12.5% { opacity: 1; transform: scaleX(0); }
  25% { opacity: 1; transform: scaleX(1); }
  37.5% { opacity: 1; transform: scaleX(1); }
  50% { opacity: 1; transform: scaleX(1); }
  75% { opacity: 1; transform: scaleX(1); }
  100% { opacity: 1; transform: scaleX(1); }
}
@keyframes contents-portrait {
  0% { opacity: 1; transform: scaleX(0) rotate(90deg); }
  12.5% { opacity: 1; transform: scaleX(0) rotate(90deg); }
  25% { opacity: 1; transform: scaleX(1) rotate(90deg); }
  37.5% { opacity: 1; transform: scaleX(1) rotate(90deg); }
  50% { opacity: 1; transform: scaleX(1) rotate(90deg); }
  75% { opacity: 1; transform: scaleX(1) rotate(90deg); }
  100% { opacity: 1; transform: scaleX(1) rotate(0deg); }
}

.outside-panels {
  z-index: 5;
  animation-name: outside-panels;
}
.env.closed > .outside-panels { opacity: .00001; }
.env.opened > .outside-panels { opacity: .00001; }
@keyframes outside-panels {
  0% { opacity: 1; transform: scaleX(0) translateY(0); }
  12.5% { opacity: 1; transform: scaleX(0) translateY(0); }
  25% { opacity: 1; transform: scaleX(1) translateY(0); }
  50% { opacity: 1; transform: scaleX(1) translateY(0); }
  75% { opacity: .00001; transform: scaleX(1) translateY(100%); }
  100% { opacity: .00001; transform: scaleX(1) translateY(100%); }
}

.outside-flap {
  z-index: 6;
  margin-left: -5%;
  width: 110%;
  transform-origin: top;
  animation-name: outside-flap;
}
.env.closed > .outside-flap { opacity: .00001; }
.env.opened > .outside-flap { opacity: .00001; }
@keyframes outside-flap {
  0% { opacity: 1; transform: scaleX(0) scaleY(1) translateY(0); }
  12.5% { opacity: 1; transform: scaleX(0) scaleY(1) translateY(0); }
  25% { opacity: 1; transform: scaleX(1) scaleY(1) translateY(0); }
  37.5% { opacity: 1; transform: scaleX(1) scaleY(0) translateY(0); }
  50% { opacity: 1; transform: scaleX(1) scaleY(0) translateY(0); }
  75% { opacity: .00001; transform: scaleX(1) scaleY(0) translateY(100%); }
  100% { opacity: .00001; transform: scaleX(1) scaleY(0) translateY(100%); }
}

.env.preview > *:not(.contents),
.env.opened > *:not(.contents) {
  pointer-events: none;
}
.env.preview > .outside-back { opacity: .00001; }
.env.preview > .inside-back { opacity: 1; transform: scaleX(1) translateY(43.3%); }
.env.preview > .inside-flap { opacity: 1; transform: scaleX(1) scaleY(1) translateY(43.3%); }
.env.preview > .contents {
  opacity: 1;
  transform: scale(1.3) translateY(-8.8%);
}

/*
.env.preview:hover > .contents + .outside-panels {
  opacity: .5;
}
*/

.env.preview > .outside-panels { opacity: 1; transform: scaleX(1) translateY(43.3%); transition: opacity .4s; }
.env.preview > .outside-flap { opacity: .00001; }

/* Some experimental styles for presenting the back of the envelope in 'preview' mode */
/*
.env.preview > .outside-back {
  z-index: 6;
  filter: drop-shadow(0 0 4px #2224) drop-shadow(0 2px 4px #2224);
  box-shadow: none;
  transform: translateY(43.3%);
}
.env.preview > .inside-flap {
  opacity: 1;
  transform: scaleX(1) scaleY(1) translateY(43.3%);
  filter: drop-shadow(0 0 4px #2224) drop-shadow(0 2px 4px #2224);
}
.env.preview > .contents {
  opacity: 1;
  transform: scale(1.3) translateY(-8.8%);
}
*/


.edit-blob-container {
  cursor: pointer;
  pointer-events: auto;
}
.edit-blob-container > .text-blob {
  position: relative;
  z-index: 1;
}
.edit-blob-scale {
  transform-origin: top left;
}
.edit-blob-outline {
  position: absolute;
  inset: 0;
  outline: 1px solid #1976d2;
  border-radius: 4px;
}
.edit-blob-label {
  display: inline-block;
  margin: 0 -1px 0 -1px;
  background: #1976d2;
  color: #FFF;
  max-width: calc(100% - 12px);
  cursor: unset;
  font-size: 12px;
  line-height: 15px;
  outline: 0 solid #1976d2;
  z-index: 1;
}
.edit-blob-container .edit-blob-label {
  display: none;
  position: absolute;
}

.dark .edit-blob-label {
  color: #344558;
  outline-color: #FFF;
  background: #FFF;
}

.dark .edit-blob-outline {
  outline-color: #FFF;
}

.edit-blob-scale.error {
  background-color: unset !important;
}
.error .edit-blob-outline {
  outline-color: #FF5252;
  box-shadow: 0 0 12px #DDD;
}
.error .edit-blob-label {
  color: #FFF;
  outline-color: #FF5252;
  background: #FF5252;
}

.edit-blob-container:hover:not(:focus-within) .edit-blob-outline {
  background-color: rgba(255, 255, 255, .08);
}

.edit-blob-container:hover .error .edit-blob-label,
.edit-blob-container:focus-within .error .edit-blob-label {
  outline-color: #FF5252;
}

.edit-blob-container:hover .edit-blob-outline,
.edit-blob-container:focus-within .edit-blob-outline {
  outline-width: 2px;
}

.edit-blob-container:has(.top) .error .edit-blob-outline,
.edit-blob-container:hover:has(.top) .edit-blob-outline,
.edit-blob-container:focus-within:has(.top) .edit-blob-outline {
  border-top-left-radius: 0;
}

.edit-blob-container:has(.bottom) .error .edit-blob-outline,
.edit-blob-container:hover:has(.bottom) .edit-blob-outline,
.edit-blob-container:focus-within:has(.bottom) .edit-blob-outline {
  border-bottom-left-radius: 0;
}

.edit-blob-label.top {
  margin-bottom: 1px;
  padding: 4px 8px;
  bottom: 100%;
  border-radius: 4px 4px 0 0;
  transform-origin: bottom left;
}

.edit-blob-label.bottom {
  margin-top: 1px;
  padding: 16px;
  top: 100%;
  border-radius: 0 0 4px 4px;
  transform-origin: top left;
}

.edit-blob-container:hover .edit-blob-label.top {
  border-bottom-width: 0;
}

.error .edit-blob-label {
  display: block;
}
.edit-blob-dialog .edit-blob-label,
.edit-blob-container:hover .edit-blob-label,
.edit-blob-container:focus-within .edit-blob-label {
  display: block;
  outline-width: 1px;
}
</style>


<script>
import AutoWidth from '@/components/AutoWidth.vue';
import CardPreview from '@/components/CardPreview.vue';
import ImageBlob from '@/components/ImageBlob.vue';
import TextBlob from '@/components/TextBlob.vue';
import { getBrightness } from '@/utils/group-video-template.js';
import transparent from '@/assets/transparent.gif';
import { mdiCheck } from '@mdi/js';

const MAX_ENV_ASPECT_RATIO = 1;
const MAX_CARD_ASPECT_RATIO = 5 / 7;

// const ENV_DESIGN = {
//   background: { img: null, color: "#F5F5F5" },
//   pages: [
//     {
//       id: '3',
//       blobs: [
//         {
//           id: 'stamp', user_id: null, x: 512, y: 752, w: 144, h: 144, r: 90, type: 'IMG',
//           img: { src: 'https://cdn.ellacard.com/i/ff227869-1eb6-4cd6-a609-2b88da8832eb', frame: null }
//         },
//         {
//           id: 'from', user_id: null, x: 524, y: 200, w: 320, h: 72, r: 90, type: 'TEXT',
//           text: { font: 'Average', color: '#000', size: 180, text: '', align: 'left', valign: 'start' },
//           template: 'cover'
//         },
//         {
//           id: 'to', user_id: null, x: 260, y: 420, w: 320, h: 240, r: 90, type: 'TEXT',
//           text: { font: 'Average', color: '#000', size: 180, text: '', align: 'center', valign: 'start' },
//           template: 'cover'
//         }
//       ]
//     }
//   ]
// };

const ENV_DESIGN_FROM = {
  id: 'from',
  user_id: '-',
  x: 505, y: 215, w: 380, h: 140, r: 90,
  type: 'TEXT',
  text: {
    font: 'Average',
    color: '#000',
    size: 50,
    text: '',
    align: 'left',
    valign: 'start',
    css: { 'line-height': '1' },
    ignore_links: true
  },
  template: 'cover'
};

const ENV_DESIGN_TO = {
  id: 'to',
  user_id: '-',
  x: 260, y: 420, w: 480, h: 240, r: 90,
  type: 'TEXT',
  text: {
    font: 'Average',
    color: '#000',
    size: 120,
    text: '',
    align: 'center',
    valign: 'center',
    css: { 'line-height': '1' },
    ignore_links: true
  },
  template: 'cover'
};

const ENV_DESIGN_STAMP = {
  id: 'stamp',
  user_id: '-',
  x: 520, y: 760, w: 144, h: 144, r: 90,
  type: 'IMG',
  img: { src: 'https://cdn.ellacard.com/i/ff227869-1eb6-4cd6-a609-2b88da8832eb', frame: null }
};

const ENV_DESIGN = {
  background: { img: null, color: "#F5F5F5" },
  pages: [ { id: '3', blobs: [ ENV_DESIGN_STAMP, ENV_DESIGN_FROM, ENV_DESIGN_TO ] } ]
};

const LABELS = { from: 'From name', to: 'To name', stamp: 'Stamp' };

export default {
  name: 'envelope',

  components: { AutoWidth, CardPreview, ImageBlob, TextBlob },

  props: {
    skin: Object,
    from: String,
    to: String,
    toMultipleRecipients: Boolean,
    preview: Boolean,

    // The aspect ratio of the envelope's contents
    aspectRatio: Number,

    // Optional: the requested widh of the envelope's contents (the resulting width will not exceed the size of the
    // root container)
    contentsWidth: Number,

    // When the card is in its 'opened' state, add a y-offset to the contents to account for the card-editor's controls
    offsetControls: { type: Number, default: 0 },

    outsideBackClass: String,

    editStamp: Boolean,
    editFrom: Boolean,
    editTo: Boolean,
    editToMultipleRecipients: Boolean,
    editToMultipleRecipientsDisabled: Boolean,
    editToMultipleRecipientsLabel: String,

    dirty: Boolean
  },

  data() {
    return {
      state: 'closed',
      delay: 0,
      isContentInside: true,
      width: 0,
      height: 0,
      containerHeight: 0,
      backCard: null,
      selected: null,
      selectedScale: 0,
      blobStamp: null,
      blobFrom: null,
      blobTo: null,
      blobs: [],
      dirtyBlobIds: []
    };
  },

  created() {
    Object.assign(this, { LABELS, mdiCheck });
  },

  computed: {
    orientation() {
      return this.aspectRatio < 1 ? 'portrait' : 'landscape';
    },

    style() {
      // The style of each of the components of the envelope (children of '.env')
      return { 'animation-duration': `${.8 * this.delay / 1000}s` };
    },

    contentsBounds() {
      // The concrete dimensions (and scale) of the envelope's contents
      const maxH = this.containerHeight - this.offsetControls;
      let w, h;
      if (this.contentsWidth) {
        w = Math.min(this.contentsWidth, this.containerWidth);
        h = w / this.aspectRatio;
      } else if (this.width / this.aspectRatio < maxH) {
        // Constrained by width
        w = this.width;
        h = w / this.aspectRatio;
      } else {
        // Constrained by height
        h = maxH;
        w = maxH * this.aspectRatio;
      }
      let scale = 1;
      if (this.isContentInside)
        // Note that we use 'h' to compute the scale if the contents are rotated
        scale = .9 * this.width / (this.aspectRatio < 1 ? h : w);
      return { w, h, scale };
    },

    contentsStyle() {
      const d = .3 * this.delay / 1000;
      const transition = `transform ${d}s`;
      const { w, h, scale } = this.contentsBounds;
      const base = { transition, 'min-width': `${w}px`, 'min-height': `${h}px` };
      if (this.isContentInside)
        return { ...base, transform: `translateY(0) scale(${scale})` };
      return { ...base, transform: `translateY(${-this.offsetControls / 2}px) scale(${scale})` };
    },

    isSmall() {
      return this.width < 400;
    },

    blobCondition() {
      const s = this.skin;
      return [
        this.from,
        this.to,
        s.env_font,
        s.env_font_color,
        s.env_stamp,
        this.editStamp,
        this.editFrom,
        this.editTo,
        this.editToMultipleRecipients,
        this.isSmall
      ];
    },

    redraw() {
      return [ this.containerHeight, this.skin.env_background_color ];
    },

    isDarkEnv() {
      return getBrightness(this.skin.env_background_color) < 160;
    }
  },

  methods: {
    onResize({ width, height }) {
      this.width = width / height > MAX_ENV_ASPECT_RATIO ? height * MAX_ENV_ASPECT_RATIO : width;
      this.height = width / height < MAX_CARD_ASPECT_RATIO ? width / MAX_CARD_ASPECT_RATIO : height;
      this.containerWidth = width;
      this.containerHeight = height;
    },

    transition(from, to, d) {
      clearTimeout(this.t1);
      this.delay = d;
      this.state = from;
      this.stateAfterTransition = to;
      this.t1 = setTimeout(() => this.state = this.stateAfterTransition, d);
    },

    async open(d=3000) {
      clearTimeout(this.t0);
      this.t0 = setTimeout(() => this.isContentInside = false, d * .7);
      this.transition('closed opening', 'opened', d);
      await new Promise(r => setTimeout(r, d));
    },

    async close(d=3000) {
      clearTimeout(this.t0);
      this.isContentInside = true;
      this.transition('opened closing', 'closed', d);
      await new Promise(r => setTimeout(r, d));
    },

    finishAnimation() {
      // Can be called externally
      clearTimeout(this.t0);
      clearTimeout(this.t1);
      this.state = this.stateAfterTransition || this.state;
      if (this.state == 'opened')
        this.isContentInside = false;
    },

    isDirty(blobId) {
      return this.dirty || this.dirtyBlobIds.includes(blobId);
    }
  },

  watch: {
    state: {
      immediate: true,
      handler(v) {
        this.$emit('update:state', v);
      }
    },

    blobCondition: {
      immediate: true,
      handler([ from, to, font, color, img_src, editStamp, editFrom, editTo, editToMultipleRecipients, isSmall ]) {
        // Note that we're carefully to explicitly bind this to a data property instead just outputting it as a
        // computed property so that we can detect updates.
        this.blobStamp = { ...ENV_DESIGN_STAMP, img: { ...ENV_DESIGN_STAMP.img, src: img_src } };
        this.blobFrom = { ...ENV_DESIGN_FROM, text: { ...ENV_DESIGN_FROM.text, text: from || '', font, color } };
        this.blobTo = { ...ENV_DESIGN_TO, text: { ...ENV_DESIGN_TO.text, text: to || '', font, color } };
        this.blobs = [
          [ this.blobStamp, img_src && ImageBlob, editStamp, false, false ],
          [ this.blobFrom, TextBlob, editFrom, false, !from ],
          [ this.blobTo, TextBlob, editTo, editToMultipleRecipients, !to ]
        ];
        if (this.selected)
          this.selected = this.blobs.find(([ blob ]) => blob.id == this.selected.id)[0];
      }
    },

    preview: {
      immediate: true,
      handler(v) {
        if (v)
          this.state = this.stateAfterTransition = 'closed preview';
      }
    },

    redraw: {
      immediate: true,
      async handler([ isVisible, color ]) {
        if (!isVisible)
          return;

        // Make sure our canvas refs have time to mount
        await this.$nextTick();

        const panels = this.$refs['outside-panels'].getContext('2d');
        panels.clearRect(0, 0, 1000, 720);
        panels.fillStyle = color;
        panels.shadowColor = '#0002';
        panels.shadowBlur = 12;
        panels.fill(new Path2D('M 0 0 L 500 360 L 0 720'));
        panels.fill(new Path2D('M 1000 0 L 500 360 L 1000 720'));
        panels.fill(new Path2D('M 0 720 Q 0 670 50 620 L 450 270 Q 500 220 550 270 L 950 620 Q 1000 670 1000 720'));

        // You could use something like the following to add textures to canvases:
        // const img = document.createElement('img');
        // img.src = 'https://www.transparenttextures.com/patterns/groovepaper.png';
        // panels.fillStyle = panels.createPattern(img, 'repeat');
        // panels.fill(new Path2D('M 0 720 Q 0 670 50 620 L 450 270 Q 500 220 550 270 L 950 620 Q 1000 670 1000 720'));

        const flap = this.$refs['outside-flap'].getContext('2d');
        flap.clearRect(0, 0, 1100, 720);
        flap.fillStyle = color;
        flap.shadowColor = '#0002';
        flap.shadowBlur = 12;
        flap.fill(new Path2D('M 50 0 Q 50 50 100 100 L 500 450 Q 550 500 600 450 L 1000 100 Q 1050 0 1050 0'));
      }
    },

    'blobFrom.text.text'(v) {
      this.dirtyBlobIds.add('from');
      this.$emit('update:from', v);
    },

    'blobTo.text.text'(v) {
      this.dirtyBlobIds.add('to');
      this.$emit('update:to', v);
    }
  }
}
</script>
